import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  icon: {
    id: 'studio.kk4TVW',
    defaultMessage: 'Icon',
  },
  iconPreview: {
    id: 'studio.CzHuqk',
    defaultMessage: 'Icon preview',
  },
  maskableIconPreview: {
    id: 'studio./JkKQQ',
    defaultMessage: 'Maskable icon preview',
  },
  minimal: {
    id: 'studio.YmRDCH',
    defaultMessage: 'Minimal safe area',
  },
  circle: {
    id: 'studio.YY4aOu',
    defaultMessage: 'Circle (Google Pixel)',
  },
  rounded: {
    id: 'studio.WGxbEB',
    defaultMessage: 'Rounded square (iPhone)',
  },
  square: {
    id: 'studio.cahQG0',
    defaultMessage: 'Full area',
  },
  more: {
    id: 'studio.TdTXXf',
    defaultMessage: 'Learn more',
  },
  deleteIconWarningTitle: {
    id: 'studio.TBqbdv',
    defaultMessage: 'Deleting logo',
  },
  deleteIconWarning: {
    id: 'studio.8fqSeD',
    defaultMessage: 'Are you sure you want to delete this app’s logo?',
  },
  cancel: {
    id: 'studio.47FYwb',
    defaultMessage: 'Cancel',
  },
  delete: {
    id: 'studio.K3r6DQ',
    defaultMessage: 'Delete',
  },
  deleteIconSuccess: {
    id: 'studio.xyO6pD',
    defaultMessage: 'Successfully deleted logo',
  },
  errorIconDelete: {
    id: 'studio.bIaXeA',
    defaultMessage: 'Something went wrong when trying to delete the logo.',
  },
});
